<template>
    <div class="kiaf-business-map-tag-group">
        <!-- 面包屑 -->
        <slot name="taggroupBreadcrumb" v-if="customize.showBreadcrumb">
            <kc-breadcrumb class="tags-breadcrumb">
                <kc-breadcrumb-item>首页</kc-breadcrumb-item>
                <kc-breadcrumb-item
                        v-for="(item,index) in  $store.state.kiaf.breadCrumbList"
                        :key="index">
                    {{item}}
                </kc-breadcrumb-item>
            </kc-breadcrumb>
        </slot>
        <div @click.prevent.stop="goForward()" class="go-forward-btn" v-if="visitedViews.length>=maxTags">
            <span><i class="kc-icon-arrow-left"></i></span>
        </div>
        <div ref="scrollPane" class="tags-view-wrapper" :class="{'tags-view-offset':visitedViews.length>=maxTags}">
            <!-- <scroll-pane ref="scrollPane" class="tags-view-wrapper" :class="{'tags-view-offset':visitedViews.length>=12}"> -->
            <template v-for="(tag,index) in visitedViews">
                <div v-if="isAppPortal(tag)"  class="tags-view-item" @click="goToAppPortal(tag)">
                    <span class="kc-icon-dot"></span>
                    <span class="tags-view-txt" :title="tag.title">{{ tag.title }}</span>
                </div>
                <div
                        ref="tag"
                        :class="isActive(tag)?'active':''"
                        :key="tag.id"
                        tag="span"
                        @click.prevent.stop="changePath(tag)"
                        class="tags-view-item"
                        v-else>
                    <span class="kc-icon-dot" :class="isActive(tag)?'active':''"></span>
                    <span class="tags-view-txt" :title="tag.title">{{ tag.title }}</span>
                    <span class="kc-icon-close" v-if="removeable(index)" @click.prevent.stop="closeSelectedTag(tag,index)"></span>
                </div>
            </template>
            <!-- </scroll-pane> -->
        </div>
        <div @click.prevent.stop="goBack()" class="go-back-btn" v-if="visitedViews.length>=maxTags">
            <span><i class="kc-icon-arrow-right"></i></span>
        </div>
    </div>
</template>

<script>
    import {postMessage} from '../../../../utils/event-bus';
    import Constants from '../../../../utils/constants';
    import Util from '../../../../utils/util';
    import Global from '../../../../utils/global';
    import mixins from '../mixins';
    export default {
        mixins: [mixins],
        data() {
          return {
            maxTags: 12 // 最大标签数量
          };
        },
        watch: {
            tagList(newVal) {
                if (newVal.length > this.maxTags) {
                    this.visitedViews = newVal.slice(newVal.length - this.maxTags, newVal.length);
                } else {
                    this.visitedViews = newVal;
                }
            },
            '$route': function () { //路由变化，改变面包屑
                let res = this.getActiveTag();
                if(res){
                  this.$store.commit('KIAF_SET_MENUACTIVEINDEX', res.id);
                  let breadCrumbList = [res.parentTitle, res.title];
                  this.$store.commit('KIAF_SET_BREADCRUMB', breadCrumbList);
                }
            }
        },
        methods: {
          removeable(index){
            if(Global.isAppPortalWebview()){
              if(Global.getMenuHomeUrl() == Constants.KIAF_URL_APP_PORTAL){
               return !(index == 0 || this.tagList.length <= 2);
              } else {
                return index >= 0;
              }
            }else{
              //保留一个页签 或者 有首页的保留2个
              return !(this.tagList.length <= 1 || (this.tagList.some(x => x.title === Constants.KIAF_MENU_HOME_TITLE) && this.tagList.length <= 2));
            }
          },
          isAppPortal(tag){
            return tag.url === Constants.KIAF_URL_APP_PORTAL;
          },
          goToAppPortal(tag){
            let appName = 'APP_PORTAL';
            if(Util.isChromeExtensionWindow()){
              if(!Util.isEmpty(Global.getParentAppHost())){
                postMessage(Constants.EVENT_BUS_CODE_APP_PORTAL_OPEN_APP, {
                    name: appName
                  },
                  [Global.getParentAppHost()]);
              } else {
                postMessage(Constants.EVENT_BUS_CODE_APP_PORTAL_OPEN_APP, {
                  name: appName
                });
              }
            } else {
              window.open('javascript:;', appName);
            }
          }
        },
        created() {
          // 根据当前显示器宽度，调整 tag 显示的个数
          let screenWidth = window.screen.availWidth;
          if (screenWidth <= 1440) {
            this.maxTags = 8;
          } else if (screenWidth > 1440 && screenWidth <= 1600) {
            this.maxTags = 10;
          }
        }
    };
</script>
<style lang="scss">
    @import "index.scss";
</style>
